/**
 * The single description of the appointment text-message program.
 *
 * The opt-in checkbox on the booking form and the terms page it links to are compared against each
 * other during carrier (A2P 10DLC) campaign review, so the disclosures live here once rather than
 * being written twice and left to drift apart. Anything a reviewer reads next to the checkbox has
 * to still be true on the terms page, and the other way round.
 */
export const smsProgram = {
  organizationName: "Multi-Service Center",
  /** The campaign name as it should appear anywhere the program is registered. */
  programName: "MSC Energy Assistance appointment alerts",

  /** Public routes. Both are reachable without signing in, which carrier review requires. */
  termsPath: "/booking/sms-terms",
  privacyPath: "/booking/privacy",

  /**
   * What a subscriber actually receives. Each line matches a message the system sends today:
   * the confirmation from BookingSmsComposer.BookingDetails, the day-before reminder scheduled at
   * booking time, and the approval prompts and their answers.
   */
  messageTypes: [
    "A confirmation with your appointment date, time, location and confirmation number",
    "A reminder the day before your appointment",
    "Updates if your appointment is changed or cancelled",
    "Replies to requests you make by text, such as asking to view or cancel your appointment",
  ],

  frequency: "Message frequency varies. Most people receive 2 to 4 messages per appointment.",
  rates: "Message and data rates may apply.",
  carrierLiability: "Carriers are not liable for delayed or undelivered messages.",
  helpAndStop: "Reply STOP to any message to stop receiving texts. Reply HELP for help.",

  /**
   * Consent language shown next to the button that submits it. Names the sender, the number, the
   * automated technology, and that consent buys nothing — leaving any of those out is the usual
   * reason an opt-in is rejected.
   */
  consentStatement:
    "By checking the box above and selecting Continue, you agree to receive text messages about your appointment from Multi-Service Center at the phone number you entered, sent using automated technology. Consent is not a condition of making an appointment or of receiving any assistance.",
} as const;
